module.exports = __webpack_public_path__ + "media/packs/images/flags/CZ-f0a6a02586d4a41316e71e6a3b8ca2ba.png";